import { DataTable } from "primereact/datatable";
import { useProvidentFundDeclaration } from "../../Hooks/Features/WelcomeKit/useProvidentFundDeclaration";
import { Column } from "primereact/column";
import FormTable from "./FormTable";
import { dateConvert, RenderSignatureField } from "../../utils/Helper";
import { useCommanKit } from "../../Hooks/Features/WelcomeKit/useCommanKit";

const ProvidentFundDeclaration = ({ label, onNext, onPrev, data, readOnly }) => {
    const { rowData, columnDefs, fieldData, callAPI, submitProvidentFundDeclaration, toggleSelection, formValues, janKYC, setJanKYC, uanKYC, setUanKYC } = useProvidentFundDeclaration({ data, label, onNext, readOnly });
    const { signature, handleChange, handleRemove } = useCommanKit({ data });

    return (
        <div className="my-2">
            <div>
                <h4 className="p-2" style={{ background: "#f2f2f2" }}>Provident Fund Declaration</h4>
            </div>
            <section className='text-center my-5'>
                <h5 className='fw-semibold'>EMPLOYEES' PROVIDENT FUND ORGANISATION</h5>
                <p> Employees' Provident Fund Scheme, 1952 (Paragraph 34 & 57) and</p>
                <p> Employees' Pension Scheme, 1995 (Paragraph 24)</p>
                <p>(Declaration by a person taking up Employment in any Establishment on which EPF Scheme, 1952 and for EPS, 1995 is applicable)</p>
            </section>

            <DataTable
                value={rowData.filter(row => row.id !== 0)}
                columns={columnDefs}
                rowGroupMode="rowspan"
                responsiveLayout="scroll"
                className="p-datatable-sm"
                rowHover
                showGridlines
                groupRowsBy="group"
            >
                {columnDefs.map((col) =>
                    !col.hide && (
                        <Column
                            key={col.field}
                            field={col.field}
                            header={col.header}
                            body={col.body}
                            style={col.style}
                            headerStyle={col.headerStyle}
                            frozen={col.frozen}
                        />
                    )
                )}

            </DataTable>
            <div>
                {Object.entries(fieldData).map(([section, fields]) => {
                    return <FormTable onPrev={onPrev} onNext={onNext} label={label} fieldsDetails={{ [section]: fields }} data={data} IsTitle={"no"} handleAPI={callAPI} familyList={[]} row={formValues} readOnly={readOnly} />
                })}
            </div>
            <div className="my-4">
                <h5 style={{ fontSize: "14px", fontWeight: "700" }} className='text-decoration-underline text-center'>UNDERTAKING</h5>
                <div>
                    <p>1. Certified that the particulars are true to the best of my knowledge</p>
                    <p>2. I authorise EPFO to use my Aadhar for verification / authentication / eKYC purpose for service delivery</p>
                    <p>3. Kindly transfer the fund and service details, if applicable, from the previous PF account as declared above to the present PF account.(The transfer would be possible only if the identified KYC details approved by previous employer has been verified by present employer using his Digital Signature)
                    </p>
                    <p>4. In case of changes in above details, the same will be intimated to employer at the earliest.</p>
                </div>
                <div className="d-flex justify-content-between my-4">
                    <div>
                        <p>Place: <strong>{data?.commonDetails?.job_location}</strong></p>
                        <p>Date: <strong>{dateConvert(data?.employee?.joining_date, "day-month-year")}</strong></p>
                    </div>
                    <div>
                        {!readOnly && <RenderSignatureField name="user_signature_url" handleChange={handleChange} value={signature} handleRemove={handleRemove} />}
                        Employee Signature
                    </div>
                </div>
            </div>
            <div className="my-4">
                <h5 style={{ fontSize: "14px", fontWeight: "700" }} className='text-decoration-underline text-center'>DECLARATION BY PRESENT EMPLOYER </h5>
                <div>
                    <p>A.The member Mr./Ms./Mrs. <b>{data?.employee?.user_display_name}</b> Has joined on <b>{dateConvert(data?.employee?.joining_date, "day-month-year")}</b> and has been alloted PF Number </p>
                    <p>B. In case the person was earlier not a member of EPF Scheme, 1952 and EPS, 1995: ((Post allotment of UAN) The UAN alloted or the member is) </p>
                    <form>
                        <p>Please Tick the Appropriate Option : The KYC details of the above member in the JAN database</p>

                        <div className="my-2">
                            {[
                                { label: "Have not been uploaded", value: "is_not_uploaded" },
                                { label: "Have been uploaded but not approved", value: "is_uploaded_but_not_approved" },
                                { label: "Have been uploaded and approved with DSC", value: "is_uploaded_and_approved_dsc" }
                            ].map(option => (
                                <div key={option.value}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="janKYC"
                                            value={option.value}
                                            checked={janKYC.includes(option.value)}
                                            onChange={() => toggleSelection(option.value, janKYC, setJanKYC)}
                                            className="mx-1"
                                        />
                                        {option.label}
                                    </label>
                                </div>
                            ))}
                        </div>

                        <p>C. In case the person was earlier a member of EPF Scheme, 1952 and EPS 1995;</p>

                        <div className="my-2">
                            {[
                                {
                                    label: "The KYC details of the above member in the UAN database have been approved with Digital Signature Certificate and transfer request has been generated on portal",
                                    value: "is_kyc_approved_with_dsc"
                                },
                                {
                                    label: "As the DSC of establishment are not registered with EPFO, the member has been informed to file physical claim (Form-13) for transfer of funds from his previous establishment.",
                                    value: "is_not_registered_with_epfo"
                                }
                            ].map(option => (
                                <div key={option.value}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="uanKYC"
                                            value={option.value}
                                            checked={uanKYC.includes(option.value)}
                                            onChange={() => toggleSelection(option.value, uanKYC, setUanKYC)}
                                            className="mx-1"
                                        />
                                        {option.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </form>
                </div>
                <div className="d-flex justify-content-between">
                    <div>
                        <p>Date: <strong>{dateConvert(data?.employee?.joining_date, "day-month-year")}</strong></p>
                    </div>
                    <div>
                        {!readOnly && <RenderSignatureField name="hr_sign" handleChange={handleChange} value={signature} handleRemove={handleRemove} lable={"Signate of Employer with Seal of Establishment"} />}
                    </div>
                </div>
            </div>
            {
                !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
                    <button className="btn-default" onClick={onPrev}>Previous</button>
                    <button className='btn-primary' onClick={submitProvidentFundDeclaration}>Proceed</button>
                </div>
            }
        </div>
    )
}

export default ProvidentFundDeclaration